<template>
  <div>
    <div
      v-if="isFrontpageActive"
      class="frontpage"
    >
      <h1 class="h2 text-center">
        {{ $t('app.name') }}
      </h1>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Frontpage",
  computed: {
    isFrontpageActive: function() {
      return this.$route.name == "lang";
    }
  }
};
</script>